import Loader from "./Loader";

export default function CenterLoader() {
  return (
    <div className="d-flex justify-content-center">
      <Loader />
    </div>
  );
}
